import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import exportService from '../services/exportService';
import toast, { Toaster } from 'react-hot-toast';

function TestExport() {
  const testData = {
    presupuesto: {
      codigo: 'TEST-001',
      nombre_obra: 'Proyecto de Prueba',
      cliente: 'Cliente Demo',
      ubicacion: 'Ciudad de México',
      fecha_elaboracion: new Date()
    },
    conceptos: [
      {
        codigo: '001',
        descripcion: 'Excavación a máquina en terreno tipo II',
        unidad: 'M3',
        cantidad: 100,
        precio_unitario: 250,
        importe: 25000
      },
      {
        codigo: '002',
        descripcion: 'Relleno compactado con material de banco',
        unidad: 'M3',
        cantidad: 50,
        precio_unitario: 180,
        importe: 9000
      }
    ],
    porcentajes: {
      indirectos: 17,
      financiamiento: 2,
      utilidad: 10,
      iva: 16
    }
  };

  const handleExcelExport = (template) => {
    console.log('Exportando a Excel con plantilla:', template);
    const result = exportService.exportToExcel(
      testData.presupuesto,
      testData.conceptos,
      testData.porcentajes,
      template
    );

    if (result.success) {
      toast.success(`✅ Exportado: ${result.fileName}`);
    } else {
      toast.error(`❌ Error: ${result.error}`);
    }
  };

  const handlePdfExport = (template) => {
    console.log('Exportando a PDF con plantilla:', template);
    const result = exportService.exportToPDF(
      testData.presupuesto,
      testData.conceptos,
      testData.porcentajes,
      template
    );

    if (result.success) {
      toast.success(`✅ Exportado: ${result.fileName}`);
    } else {
      toast.error(`❌ Error: ${result.error}`);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Toaster position="top-right" />

      <Typography variant="h4" gutterBottom>
        Prueba de Exportación con Plantillas
      </Typography>

      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Plantillas de Excel
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
          <Button
            variant="contained"
            color="success"
            onClick={() => handleExcelExport('standard')}
          >
            📊 Excel Estándar
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => handleExcelExport('detallada')}
          >
            📋 Excel Detallada
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => handleExcelExport('simplificada')}
          >
            📄 Excel Simplificada
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => handleExcelExport('corporativa')}
          >
            🏢 Excel Corporativa
          </Button>
        </Box>

        <Typography variant="h6" gutterBottom>
          Plantillas de PDF
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            color="error"
            onClick={() => handlePdfExport('standard')}
          >
            📄 PDF Estándar
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => handlePdfExport('detallada')}
          >
            📊 PDF Detallada
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => handlePdfExport('ejecutiva')}
          >
            💼 PDF Ejecutiva
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => handlePdfExport('minimalista')}
          >
            ⬜ PDF Minimalista
          </Button>
        </Box>
      </Paper>

      <Paper sx={{ p: 2, mt: 3, bgcolor: 'grey.100' }}>
        <Typography variant="body2" color="text.secondary">
          <strong>Datos de prueba:</strong>
        </Typography>
        <Typography variant="body2">
          • Proyecto: {testData.presupuesto.nombre_obra}
        </Typography>
        <Typography variant="body2">
          • Cliente: {testData.presupuesto.cliente}
        </Typography>
        <Typography variant="body2">
          • Conceptos: {testData.conceptos.length}
        </Typography>
      </Paper>
    </Box>
  );
}

export default TestExport;